// Storage configuration and utilities for Supabase
export const STORAGE_BUCKETS = {
  USER_AVATARS: 'user-avatars',
  PRAYER_AUDIO: 'prayer-audio',
  PRAYER_ATTACHMENTS: 'prayer-attachments',
  HERO_IMAGES: 'hero-images',
  AUDIO_CACHE: 'audio_cache',
} as const;

export type StorageBucket = typeof STORAGE_BUCKETS[keyof typeof STORAGE_BUCKETS];

export const APP_IMAGES = {
  abielAvatar: '/lovable-uploads/ce51ed65-a31b-4d9d-8a10-40b07d9f4ec7.png',
  defaultAvatar: '/lovable-uploads/ce51ed65-a31b-4d9d-8a10-40b07d9f4ec7.png',
  prayerFlame: '/lovable-uploads/ce51ed65-a31b-4d9d-8a10-40b07d9f4ec7.png', // Using abiel avatar as placeholder
  welcomeIconLight: '/lovable-uploads/79ab9692-bb11-45ec-bc0e-fc0941395166.png', // Updated "Let's Pray" icon for light theme
  welcomeIconDark: '/lovable-uploads/79ab9692-bb11-45ec-bc0e-fc0941395166.png', // Updated "Let's Pray" icon for dark theme
  communityIconLight: '/lovable-uploads/e5e50d55-c0ca-4ca9-9107-4c23a2c07207.png', // Black church icon for light theme
  communityIconDark: '/lovable-uploads/7f415b4d-a4ea-40f2-b44a-4bb3840353ef.png', // Gold church icon for dark theme
} as const;

export const AVATAR_CONFIG = {
  MAX_FILE_SIZE: 5 * 1024 * 1024, // 5MB
  ALLOWED_TYPES: ['image/jpeg', 'image/png', 'image/gif', 'image/webp'] as const,
  DIMENSIONS: {
    SMALL: 32,
    MEDIUM: 64,
    LARGE: 128,
    PROFILE: 96,
  },
} as const;

// Helper functions for getting URLs
export const getAbielAvatarUrl = (siteUrl?: string): string => {
  const baseUrl = siteUrl || '';
  return `${baseUrl}${APP_IMAGES.abielAvatar}`;
};

export const getAppLogoUrl = (): string => {
  return APP_IMAGES.abielAvatar; // Using abiel avatar as app logo
};

export const getWelcomeIconUrl = (theme: 'light' | 'dark'): string => {
  return theme === 'dark' ? APP_IMAGES.welcomeIconDark : APP_IMAGES.welcomeIconLight;
};

export const getCommunityIconUrl = (theme: 'light' | 'dark'): string => {
  return theme === 'dark' ? APP_IMAGES.communityIconDark : APP_IMAGES.communityIconLight;
};

export const getStorageUrl = (bucket: StorageBucket, path: string): string => {
  return `https://daeuiiggqdxyseiekbca.supabase.co/storage/v1/object/public/${bucket}/${path}`;
};

export const validateImageFile = (file: File): { isValid: boolean; error?: string } => {
  if (file.size > AVATAR_CONFIG.MAX_FILE_SIZE) {
    return {
      isValid: false,
      error: `File size must be less than ${AVATAR_CONFIG.MAX_FILE_SIZE / (1024 * 1024)}MB`,
    };
  }

  if (!AVATAR_CONFIG.ALLOWED_TYPES.includes(file.type as typeof AVATAR_CONFIG.ALLOWED_TYPES[number])) {
    return {
      isValid: false,
      error: 'File must be an image (JPEG, PNG, GIF, or WebP)',
    };
  }

  return { isValid: true };
};
